module.exports = __webpack_public_path__ + "img/礼物-2.448f017f.png";